import styled, { css } from 'styled-components';
import { cssColorVar, defaultColorSet, rootStyle } from "../../styles";
export var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "c1ixcy-0"
})(["", ""], function (props) {
  var semanticBackgroundColorValue = cssColorVar(props.semanticBackgroundColor);
  return css(["", ";position:absolute;top:0;left:0;display:flex;flex-direction:column;inline-size:100%;min-block-size:100%;background:var(", ",", ");color:var(--text-base,", ");overflow-wrap:break-word;"], rootStyle(), semanticBackgroundColorValue, defaultColorSet.background.base, defaultColorSet.text.base);
});
export default Container;